module.exports = __webpack_public_path__ + "static/media/available-active.47853c4e.svg";